<!-- <div mat-dialog-content> -->
  <div class="dialog-image" [style.background-image]="data.image_url" (click)="close()"></div>
<!-- </div> -->
